import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '../AuthProvider'
import { FullScreenLoader } from './FullScreenLoader'

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthorized, isAuthorizeLoading } = useAuth()
  const location = useLocation()
  if (isAuthorizeLoading) return <FullScreenLoader />
  if (!isAuthorized) return <Navigate to="/auth" replace state={{ from: location }} />
  return <>{children}</>
}
